import React, { Component } from 'react'
import './imd-student-winners.scss'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import FilterComponent from '../filter/filter'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faCheckCircle,
  faTicketAlt,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
import { Constants } from '../../../constants/constants'

class IMDStudentWinnersList extends Component {
  state = {
    imdStudents: [],
    meta: { totalPages: 1, page: 1 },
    isLoading: false,
    selectedPage: 1
  }
  limit = 10
  currentPage = 1
  startIndex = 1
  filter = {}
  constructor (props) {
    super(props)
    this.gmcAllowed = this.props.gmcAllowed
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getIMDWinnersList(payload)
  }

  getIMDWinnersList = (payload = {}) => {
    payload.eventId = this.gmcAllowed ? Constants.GMC_EVENT_ID: Constants.IMD_EVENT_ID
    const { selectedClass } = this.state
    const { fromScreen } = this.props
    this.setState({
      isLoading: true
    })
    if (!payload.class && selectedClass) payload.class = selectedClass
    if (!payload.page) payload.page = 1
    if (!payload.limit)
      payload.limit = fromScreen === 'assessment-chart' ? 3 : this.limit
    
    payload.winners = true
    this.currentPage = payload.page

    if (this.currentPage === 1) this.startIndex = 1

    SchoolUserApi.getIMDWinnersList(payload)
      .then(result => {
        this.setState({
          imdStudents: result.response,
          meta: result.meta,
          isLoading: false,
          basePath: result.basePath
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.filter.page = selectedPage
    this.setState({ selectedPage })
    this.getIMDWinnersList(this.filter)
  }

  getIMDRankCategory = rank => {
    if (rank === 1) {
      return 'Gold Medal winner'
    } else if (rank === 2) {
      return 'Silver Medal winner'
    } else if (rank === 3) {
      return 'Bronze Medal winner'
    } else if (rank <= 10) {
      return 'Top 10 Rankers'
    } else if (rank <= 30) {
      return 'Top 30 Rankers'
    } else if (rank <= 75) {
      return 'Top 75 Rankers'
    } else if (rank <= 150) {
      return 'Top 150 Rankers'
    } else if (rank <= 250) {
      return 'Top 250 Rankers'
    } else if (rank <= 500) {
      return 'Enthusiast'
    }
  }


  render () {
    const { imdStudents, basePath } = this.state
    const { fromScreen } = this.props
    console.log(fromScreen)
    return (
      <>
        <div
          id='table-scoll'
          className='student-winners-list table-responsive mt-5'
        >
          {this.state.isLoading && <Loading style={{ top: '100px' }}></Loading>}
          <table className='table cw-table mb-0 align-items-center student-winners'>
            <thead>
              <tr>
                <th className='text-center th-left-radius'>Rank</th>
                <th className='text-center'>Name</th>
                <th className='text-center'>Category</th>
                <th className='text-center th-right-radius'>Class</th>
              </tr>
            </thead>
            <tbody className='bg-white'>
              {imdStudents.length > 0 &&
                imdStudents.map((student, index) => (
                  <tr key={index} className='mt-4'>
                    <td className='student-rank text-center'>{student.rank}</td>
                    <td className='text-center'>
                      <div className='student-name'>
                        <div className='user-image text-right pr-4'>
                          {student.image ? (
                            <img
                              alt='img'
                              src={`${basePath}${student.image}`}
                            />
                          ) : (
                            <img
                              alt='img'
                              src={Constants.ALTERNATE_STUDENT_IMAGE}
                            />
                          )}
                        </div>
                        <div className='name-text text-left'>
                          {student?.name}
                        </div>
                      </div>
                    </td>
                    <td className='text-center'>{this.getIMDRankCategory(student.rank)}</td>
                    <td className='text-center'>{student.class}</td>
                  </tr>
                ))}
              {!imdStudents.length && (
                <tr className='mt-4'>
                  <td colSpan='8' className='text-center'>
                    {' '}
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {fromScreen !== "assessment-chart" && !this.state.isLoading && this.state.meta.totalPages ? (
            <div className='card-footer'>
              <PaginationComponent
                startIndex={this.startIndex}
                selectedPage={this.currentPage}
                totalPages={this.state.meta.totalPages}
                onPageSelected={this.onPageSelected.bind(this)}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </>
    )
  }
}

export default IMDStudentWinnersList
